export function getGatewayURL() {
  const hostname = window.location.hostname;
  const environmentMappings = {
    'goat-stage': 'https://gateway.stg.demandbase.com',
    'goat-dev': 'https://gateway.gdpr-dev.demandbase.com',
    'goat-prod': 'https://gateway.demandbase.com',
  };
  for (const [env, targetUrl] of Object.entries(environmentMappings)) {
    if (hostname.includes(env)) {
      return targetUrl;
    }
  }

  return environmentMappings['goat-prod'];
}

export const parseCookies = (cookie: string) => {
  return cookie.split(';').reduce((cookies: Record<string, string>, cookie: string) => {
    const [key, value] = cookie.trim().split('=');
    cookies[key] = decodeURIComponent(value);
    return cookies;
  }, {});
};
